import { render, staticRenderFns } from "./SymptomReport.vue?vue&type=template&id=853acb4a&"
import script from "./SymptomReport.vue?vue&type=script&lang=ts&"
export * from "./SymptomReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports